import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../context/I18nContext";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="protected-loading">
        <p>{t("protectedRoute.loading")}</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Unverified teachers are locked out of the platform until an admin verifies them.
  if (user?.role === "teacher" && !user.is_verified) {
    if (location.pathname !== "/pending-verification") {
      return <Navigate to="/pending-verification" replace />;
    }
  } else if (location.pathname === "/pending-verification") {
    return <Navigate to="/dashboard" replace />;
  }

  // Only REAL student accounts are restricted to a small set of pages.
  // Parents may temporarily operate in "student mode" (effectiveRole === 'student')
  // to view a child, but they still must be able to access parent pages.
  if (user?.role === "student") {
    const allowedPrefixes = [
      "/dashboard",
      "/profile",
      "/lessons",
      "/homeworks",
      "/resources",
      "/contact",
      "/placement-test",
    ];

    const isAllowed = allowedPrefixes.some(
      (prefix) =>
        location.pathname === prefix ||
        location.pathname.startsWith(`${prefix}/`),
    );

    if (!isAllowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
